










import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/menu/Header.vue';
import ListEmployees from '@/components/employee/ListEmployees.vue';

@Component({
  components: {
    Header,
    ListEmployees
  },
})
export default class EmployeesList extends Vue {}
